/* eslint-disable import/first */
import React, { useEffect } from 'react';
/* eslint-disable import/first */
import Hreflang from '../../components/Hreflang';
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import Grid from '@material-ui/core/Grid';
import Skeleton from 'react-loading-skeleton';
const { selectDesktop } = Slices.appSlice;
const { fetchFaq, selectFaq } = Slices.faqSlice;
import FaqContainer from './FaqContainer';
import SeoTitle from '../../components/SeoTitle';
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';

function Faq() {
  const dispatch = useDispatch();
  // const faq = useSelector(selectFaqRootState);
  // eslint:fix
  const config = useSelector((state) => state.config);
  const faqList = useSelector(selectFaq);
  const isDesktop = useSelector(selectDesktop);
  //const faqList = [...obj];

  useEffect(() => {
    dispatch(fetchFaq());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  if (config.status !== 'succeeded') {
    return <Skeleton count={10} className={css.Skeleton} height={56} />;
  }

  return (
    <Grid>
      <SeoTitle id="faq" />
      <Hreflang page="faq" />
      <Header
        title={<FormattedMessage id="navigation_faq" defaultMessage="FAQs" />}
        actionButtons={[<LanguageButton />]}
        // actionButtons={[<LanguageButton />]}
      />
      {isDesktop ? (
        <Grid className={css.desktopContainer}>
          <div className={css.pageHeading}>
            <FormattedMessage id="navigation_faq" defaultMessage="FAQs" />
          </div>
          <Grid className={css.desktopView}>
            <FaqContainer faqList={faqList} />
          </Grid>
        </Grid>
      ) : (
        <FaqContainer isDesktop={isDesktop} faqList={faqList} />
      )}

      <footer className={css.footer}></footer>
    </Grid>
  );
}

export default Faq;
